(function(){
  var DATA=(window.vehicleFitmentData||[]).filter(function(x){return !x.status||String(x.status).toLowerCase()==='active'});
  var customizeLink='/pages/customize-your-wrap';
  var pageSize=24, shown=pageSize, searchTerm='', selectedMake='', selectedModel='', selectedYear='';
  var el={
    search:document.getElementById('vf-search'),
    make:document.getElementById('vf-make-filter'),
    model:document.getElementById('vf-model-filter'),
    year:document.getElementById('vf-year-filter'),
    makeList:document.getElementById('vf-make-options'),
    modelList:document.getElementById('vf-model-options'),
    yearList:document.getElementById('vf-year-options'),
    results:document.getElementById('vf-results'),
    count:document.getElementById('vf-count'),
    reset:document.getElementById('vf-reset'),
    load:document.getElementById('vf-load'),
    topBrands:document.getElementById('vf-top-brands')
  };
  function esc(s){return String(s||'').replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
  function norm(s){return String(s||'').trim()}
  function lower(s){return norm(s).toLowerCase()}
  function yearLabel(x){var a=norm(x.yearFrom),b=norm(x.yearTo);if(a&&b)return a===b?a:a+'-'+b;if(a)return a;if(b)return b;return 'Year not listed'}
  function countryLabel(x){return norm(x.country)||'Country not listed'}
  function coversYear(x,y){
    if(!y)return true;
    var yf=parseInt(x.yearFrom,10),yt=parseInt(x.yearTo,10),yy=parseInt(y,10);
    if(isNaN(yy))return true;
    if(!isNaN(yf)&&!isNaN(yt))return yy>=yf&&yy<=yt;
    if(!isNaN(yf))return yy===yf;
    if(!isNaN(yt))return yy===yt;
    return false;
  }
  function uniq(arr){var seen={},out=[];arr.forEach(function(v){v=norm(v);var key=lower(v);if(v&&!seen[key]){seen[key]=1;out.push(v)}});return out.sort(function(a,b){return a.localeCompare(b,undefined,{numeric:true,sensitivity:'base'})})}
  function terms(){return lower(searchTerm).split(/\s+/).filter(Boolean)}
  function textMatch(value, filter){value=lower(value);filter=lower(filter);return !filter || value.indexOf(filter)>-1}
  function isYearToken(w){return /^\d{4}$/.test(String(w||''))}
  function wordMatchesVehicle(x,w){
    if(isYearToken(w))return coversYear(x,w);
    var hay=lower([x.make,x.model,x.yearFrom,x.yearTo,x.country,x.sku].join(' '));
    return hay.indexOf(w)>-1;
  }
  function passesSearch(x){var t=terms();if(!t.length)return true;return t.every(function(w){return wordMatchesVehicle(x,w)})}
  function rowPassesFilters(x,ignore){
    if(ignore!=='make'&&selectedMake&&!textMatch(x.make,selectedMake))return false;
    if(ignore!=='model'&&selectedModel&&!textMatch(x.model,selectedModel))return false;
    if(ignore!=='year'&&selectedYear&&!coversYear(x,selectedYear))return false;
    if(!passesSearch(x))return false;
    return true;
  }
  function scoreRow(x,t){
    var hay=lower([x.make,x.model,x.yearFrom,x.yearTo,x.country,x.sku].join(' '));
    var s=0;
    t.forEach(function(w){
      if(isYearToken(w)&&coversYear(x,w))s+=25;
      else if(hay.indexOf(w)>-1)s+=10;
      if(lower(x.make+' '+x.model).indexOf(w)>-1)s+=20;
      if(String(x.yearFrom).indexOf(w)>-1||String(x.yearTo).indexOf(w)>-1)s+=12;
    });
    if(selectedMake&&textMatch(x.make,selectedMake))s+=30;
    if(selectedModel&&textMatch(x.model,selectedModel))s+=35;
    if(selectedYear&&coversYear(x,selectedYear))s+=25;
    return s;
  }
  function filteredRows(){return DATA.filter(function(x){return rowPassesFilters(x)})}
  function compactCountries(rows){
    var vals=uniq(rows.map(function(x){return countryLabel(x)}));
    if(vals.length<=4)return vals.join(', ');
    return vals.slice(0,4).join(', ')+' +'+(vals.length-4)+' more';
  }
  function modelSummary(rows){
    var models=uniq(rows.map(function(x){return x.model}));
    if(models.length<=3)return models.join(' / ');
    return models.slice(0,3).join(' / ')+' +'+(models.length-3)+' more models';
  }
  function makeSummary(rows){
    var makes=uniq(rows.map(function(x){return x.make}));
    if(makes.length<=3)return makes.join(' / ');
    return makes.slice(0,3).join(' / ')+' +'+(makes.length-3)+' more makes';
  }
  function representativeImage(rows){
    var counts={},best='',bestCount=0;
    rows.forEach(function(x){var im=norm(x.image); if(!im)return; counts[im]=(counts[im]||0)+1; if(counts[im]>bestCount){best=im;bestCount=counts[im]} });
    return best;
  }
  function uniqueFitments(rows){
    var seen={},out=[];
    rows.forEach(function(x){
      var key=lower([x.make,x.model,yearLabel(x),countryLabel(x)].join('|'));
      if(!seen[key]){seen[key]=1;out.push(x)}
    });
    out.sort(function(a,b){return (a.make||'').localeCompare(b.make||'')||(a.model||'').localeCompare(b.model||'')||yearLabel(a).localeCompare(yearLabel(b),undefined,{numeric:true})||countryLabel(a).localeCompare(countryLabel(b))});
    return out;
  }
  function groupBySku(rows){
    var map={}, groups=[];
    rows.forEach(function(x){
      var key=norm(x.sku)||('NO-SKU-'+norm(x.image)+'-'+norm(x.make));
      if(!map[key]){map[key]={sku:key,rows:[],_score:0};groups.push(map[key])}
      map[key].rows.push(x);
    });
    var t=terms();
    groups.forEach(function(g){
      var maxScore=0;
      g.rows.forEach(function(r){maxScore=Math.max(maxScore,scoreRow(r,t))});
      g._score=maxScore;
      g.image=representativeImage(g.rows);
      g.fitments=uniqueFitments(g.rows);
      g.makes=makeSummary(g.rows);
      g.models=modelSummary(g.rows);
      g.countries=compactCountries(g.rows);
    });
    groups.sort(function(a,b){return (b._score-a._score)||a.makes.localeCompare(b.makes)||a.models.localeCompare(b.models)||a.sku.localeCompare(b.sku)});
    return groups;
  }
  function fillDatalist(listEl, values){listEl.innerHTML=values.slice(0,700).map(function(v){return '<option value="'+esc(v)+'"></option>'}).join('')}
  function rowsForMakeList(){return DATA.filter(passesSearch)}
  function rowsForModelList(){return DATA.filter(function(x){return (!selectedMake||textMatch(x.make,selectedMake))&&passesSearch(x)})}
  function rowsForYearList(){return DATA.filter(function(x){return (!selectedMake||textMatch(x.make,selectedMake))&&(!selectedModel||textMatch(x.model,selectedModel))&&passesSearch(x)})}
  function updateFilters(){
    fillDatalist(el.makeList, uniq(rowsForMakeList().map(function(x){return x.make})));
    if(selectedMake){
      el.model.disabled=false;
      el.model.placeholder='Filter model';
      fillDatalist(el.modelList, uniq(rowsForModelList().map(function(x){return x.model})));
    }else{
      el.model.disabled=true;
      el.model.placeholder='Select make first';
      fillDatalist(el.modelList, []);
    }
    if(selectedMake&&selectedModel){
      el.year.disabled=false;
      el.year.placeholder='Filter year';
      var years=[];
      rowsForYearList().forEach(function(x){
        var a=parseInt(x.yearFrom,10),b=parseInt(x.yearTo,10);
        if(!isNaN(a)&&!isNaN(b)){for(var y=a;y<=b&&y<=2035;y++)years.push(String(y))}
        else if(!isNaN(a))years.push(String(a));
        else if(!isNaN(b))years.push(String(b));
      });
      fillDatalist(el.yearList, uniq(years).sort(function(a,b){return parseInt(b,10)-parseInt(a,10)}));
    }else{
      el.year.disabled=true;
      el.year.placeholder='Select model first';
      fillDatalist(el.yearList, []);
    }
  }
  function renderFitmentRows(rows){
    var display=rows.slice(0,70).map(function(x){
      return '<div class="vf-fitment-row"><strong>'+esc(x.make+' '+x.model)+'</strong><br><span>'+esc(yearLabel(x))+' • '+esc(countryLabel(x))+'</span></div>';
    }).join('');
    if(rows.length>70)display+='<div class="vf-fitment-row">+'+esc(rows.length-70)+' more compatible vehicles</div>';
    return display;
  }
  function render(){
    updateFilters();
    var rows=filteredRows();
    var groups=groupBySku(rows);
    var visible=groups.slice(0,shown);
    el.count.textContent=groups.length?(groups.length+' matching wheel option'+(groups.length===1?'':'s')+' found for '+rows.length+' vehicle fitment'+(rows.length===1?'':'s')):'No matching vehicles found';
    if(!groups.length){
      el.results.className='';
      el.results.innerHTML='<div class="vf-empty"><strong>Can’t find your vehicle?</strong><br>Send us your vehicle make, model, year, and a steering wheel photo. We will check compatibility for you.</div>';
      el.load.style.display='none';
      return;
    }
    el.results.className='vf-grid';
    el.results.innerHTML=visible.map(function(g){
      return '<div class="vf-card">'+
        '<div class="vf-img-wrap"><img loading="lazy" src="'+esc(g.image)+'" alt="'+esc(g.makes+' '+g.models+' steering wheel')+'"></div>'+
        '<div class="vf-body">'+
          '<div class="vf-make">'+esc(g.makes)+'</div>'+
          '<div class="vf-model">'+esc(g.models)+'</div>'+
          '<div class="vf-small">If this steering wheel is the same as yours, we can make a custom-fit wrap for it.</div>'+
          '<div class="vf-meta"><span class="vf-chip">'+(g.fitments.length===1?'Wheel used in 1 vehicle':'Wheel used in '+esc(g.fitments.length)+' vehicles')+'</span></div>'+
          '<details class="vf-list"><summary>More details of models</summary><div class="vf-fitments">'+renderFitmentRows(g.fitments)+'</div></details>'+
          '<a class="vf-btn" href="'+customizeLink+'">See available wrap options</a>'+
        '</div>'+
      '</div>';
    }).join('');
    el.load.style.display=groups.length>shown?'block':'none';
  }
  function populateTopBrands(){
    var top=['Toyota','Ford','BMW','Mercedes-Benz','Holden','Nissan','Mazda','Volkswagen','Subaru','Isuzu','BYD'];
    el.topBrands.innerHTML=top.filter(function(b){return DATA.some(function(x){return x.make===b})}).map(function(b){return '<button type="button" class="vf-brand-pill" data-brand="'+esc(b)+'">'+esc(b)+'</button>'}).join('');
  }
  function triggerRender(){shown=pageSize;render()}
  var timer;
  el.search.addEventListener('input',function(e){
    clearTimeout(timer);
    timer=setTimeout(function(){
      searchTerm=e.target.value;
      shown=pageSize;
      Array.prototype.forEach.call(document.querySelectorAll('.vf-brand-pill'),function(btn){btn.classList.toggle('active',btn.getAttribute('data-brand')===selectedMake)});
      render();
    },180);
  });
  el.make.addEventListener('input',function(){selectedMake=this.value;selectedModel='';selectedYear='';el.model.value='';el.year.value='';triggerRender()});
  el.model.addEventListener('input',function(){selectedModel=this.value;selectedYear='';el.year.value='';triggerRender()});
  el.year.addEventListener('input',function(){selectedYear=this.value;triggerRender()});
  el.reset.addEventListener('click',function(){
    searchTerm=''; selectedMake=''; selectedModel=''; selectedYear=''; shown=pageSize;
    el.search.value=''; el.make.value=''; el.model.value=''; el.year.value='';
    Array.prototype.forEach.call(document.querySelectorAll('.vf-brand-pill'),function(btn){btn.classList.remove('active')});
    render();
  });
  el.load.addEventListener('click',function(){shown+=pageSize;render()});
  el.topBrands.addEventListener('click',function(e){
    var b=e.target.getAttribute('data-brand'); if(!b)return;
    searchTerm=''; selectedMake=b; selectedModel=''; selectedYear=''; shown=pageSize;
    el.search.value=''; el.make.value=b; el.model.value=''; el.year.value='';
    Array.prototype.forEach.call(document.querySelectorAll('.vf-brand-pill'),function(btn){btn.classList.toggle('active',btn.getAttribute('data-brand')===b)});
    render();
  });
  populateTopBrands();
  render();
})();
